import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'

document.addEventListener('DOMContentLoaded', () => {
  const swiperContainers = document.querySelectorAll('.c1005');

  swiperContainers.forEach((container) => {
    let swiperElement = container.querySelector('.c1005-swiper');

    const swiper = new Swiper(swiperElement, {
      modules: [Navigation],
      loop: false,
      slidesPerView: 1,
      spaceBetween: 30,
      grabCursor: true,
      navigation: {
        nextEl: container.querySelector('.c1005-button-next'),
        prevEl: container.querySelector('.c1005-button-prev'),
      },
    });

    let buttons = container.querySelectorAll('.c1005 button');
    let popup = container.querySelector('.popup');

    if (buttons.length > 0 && popup) {
      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          popup.classList.remove('translate-y-full');

          let slideIndex = button.getAttribute('data-slide-index');
          if (swiper && slideIndex !== null) {
            swiper.slideTo(parseInt(slideIndex), 1, true);
          }
        });
      });

      let closeButtons = popup.querySelectorAll('.close-popup');
      closeButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          popup.classList.add('translate-y-full');
        });
      });
    }
  });
});

